export default __webpack_public_path__ + "static/trailer_hd-20a08a420d35a16e8a29dab62cb1076b.mp4";